////import { Component, OnInit } from '@angular/core';
////import { Router, ActivatedRoute, ParamMap } from '@angular/router';

////@Component({
////  selector: 'app-header',
////  templateUrl: './header.component.html',
////  styleUrls: ['./header.component.css']
////})
////export class HeaderComponent implements OnInit {

////  constructor(private router: Router) { }

////  ngOnInit() {
////    //this.router.navigate(['/']);
////  }

////}

import { Component, EventEmitter, OnInit, Input, Output, Renderer2, SimpleChanges, ViewChild, HostListener, Inject, ChangeDetectionStrategy, NgZone } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthenticationService } from '../shared/services/authentication.service';
import { basketVM } from '../shared/viewmodels/basketVM';
import { ccPaymentVM } from '../shared/viewmodels/ccPaymentVM';
import { ShoppingBasketService } from '../shared/services/shopping-basket.service';
import { CCPaymentService } from '../shared/services/cc-payment-service';
import { DocBasketExComponent } from '../shared/components/doc-basket-ex/doc-basket-ex.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {

  loginLink: string = "";
  menuItems: any;
  @Input() basketItems: Array<basketVM>;
  basketItem: basketVM;
  ccPmt: ccPaymentVM;
  evtEmitter = new EventEmitter();
  @ViewChild(DocBasketExComponent, { static: false }) docBasketChild;

  constructor(private router: Router, public service: AuthenticationService, private SBservice: ShoppingBasketService, private ccPmtSvc: CCPaymentService) {
    this.basketItems = new Array<basketVM>();
    this.ccPmt = new ccPaymentVM();

    if (localStorage.getItem("basket") !== null && localStorage.getItem("basket").length > 0) {
      this.basketItems = JSON.parse(localStorage.getItem("basket"));
      //localStorage.clear();
    }
  }

  async ngOnInit() {
    //this.router.navigate(['/']);

    //figure out what the role of the machine is
  let loc = localStorage.getItem("machineLocation");
    console.log('loc ' + loc);
    if (loc === undefined || loc === null || loc === '0')
      this.service.showLogin = true;
    else
      this.service.showLogin = false;

    if (localStorage.getItem('uid') === null || localStorage.getItem('guid') === null)
      this.service.loginLink = "Login";
    else {
      //check if guid is valid
      if (localStorage.getItem('guid') > '') {
        await this.service.ValidateGuid();
        console.log('ret - ' + this.service.success);
        if (this.service.success > 0) {
          //valid session
          console.log('true');
          this.service.isLoggedIn = true;
          this.service.loginLink = localStorage.getItem('uid');
          this.service.uid = localStorage.getItem('uid');
          this.service.guid = localStorage.getItem('guid');
        }
        else {
          console.log('false');
          this.service.loginLink = "Login";
        }
      }
      else {
      }
    }
  }

  getCredentials() {
    //console.log('login call');
    this.service.getCredentials();
  }

  //getBasket() {
  //  console.log('get basket');
  //}

  //logout() {
  //  //console.log('login call');
  //  this.service.logout();
  //}

  changePassword() {
    //console.log('login call');
    this.service.changePassword();
  }

  menuClick(item) {

    if (item === 1)
      this.service.getAccountActivity();

    else if (item === 2)
      this.service.logout();

  }
}
